<template>
  <div class="product-list-container">
    <div class="product-list-header">
      <!-- <h2>商品列表</h2> -->
    </div>
    <div class="product-list">
      <el-card v-for="product in productList" :key="product.id" class="product-item"
               @click.native="goToProductDetail(product.id)">
        <div class="product-image">
          <img :src="product.coverImg" alt="商品封面"/>
        </div>
        <div class="product-info">
          <h3>{{ product.title }}</h3>
          <p v-if="product.subTitle">{{ product.subTitle }}</p>
          <div class="product-price">
            <span class="price-unit">¥</span>
            <span class="price">{{ product.price }}</span>
            <span v-if="product.marketPrice" class="market-price">¥{{ product.marketPrice }}</span>
            <span class="price-unit">起</span>
          </div>
          <div class="product-stock">库存: {{ product.stock }}件</div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
/**
 * 商品列表页面组件
 * 业务背景：展示所有可购买的商品，用户可以通过点击商品卡片进入商品详情页
 * 设计决策：将商品列表与商品详情拆分为独立页面，提升代码可维护性和用户体验
 */
import {shopRequest} from "@/utils/utils";

export default {
  name: "ProductList",
  data() {
    return {
      productList: [] // 商品列表数据
    };
  },

  /**
   * 组件创建时获取商品列表
   * 业务背景：页面加载时需要展示所有可购买的商品
   * 设计决策：在 created 生命周期中异步获取数据，避免阻塞页面渲染
   */
  async created() {
    try {
      const data = {
        pageNum: 1,
        pageSize: 10
      };
      const response = await shopRequest('post', '/getProductList', data);
      this.productList = response;
    } catch (error) {
      console.error('获取商品列表失败:', error);
      this.$message.error('获取商品列表失败');
    }
  },

  methods: {
    /**
     * 跳转到商品详情页面
     * 业务背景：用户点击商品卡片时需要查看商品详细信息
     * 设计决策：通过路由参数传递商品ID，详情页根据ID获取商品数据，实现页面解耦
     * @param {string|number} productId - 商品ID
     */
    goToProductDetail(productId) {
      this.$router.push({
        name: 'ProductDetail',
        params: { productId: productId }
      });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  text-align: left;
}

div {
  display: block;
  box-sizing: border-box;
}

img {
  border: 0;
  vertical-align: top;
  display: inline-block;
}

/* 商品列表样式 */
.product-list-container {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

/* 网页端版心设置 - 占屏幕80%宽度 */
@media (min-width: 769px) {
  .product-list-container {
    width: 80%;
    max-width: 100%;
    margin: 0 auto;
    padding: 40px 60px;
  }
}

.product-list-header {
  margin-bottom: 20px;
  text-align: center;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.product-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.product-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.product-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  position: relative;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.product-info {
  padding: 15px;
}

.product-info h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
}

.product-info p {
  margin: 0 0 12px 0;
  color: #999;
  font-size: 14px;
}

.product-price {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: bold;
  color: #ff7452;
}

.price-unit {
  color: #ff7452;
  font-size: 10px;
}

.market-price {
  margin-left: 8px;
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

.product-stock {
  margin: 0;
  color: #666;
  font-size: 14px;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .product-list-container {
    padding: 10px;
  }

  .product-list {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .product-image {
    width: 100%;
    aspect-ratio: 1 / 1;
  }

  .product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .product-info {
    padding: 12px;
  }

  .product-info h3 {
    font-size: 15px;
  }

  .product-info p {
    font-size: 13px;
  }

  .product-price {
    font-size: 16px;
  }

  .product-stock {
    font-size: 13px;
  }
}
</style>

